module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-250.952cd86a.png";